<template>
  <div class="form-wrapper">
    <div class="placeholer"></div>
    <div class="placeholer"></div>
    <div class="brand">
      <div><img src="../../assets/LogoD.png" alt="Logo" class="logo" /></div>      
      <!-- <div class="platname">RE-POC</div> 
      <div class="subtitle">Real Estate Management System</div>-->
    </div>
    <form @submit.prevent="login">
      <div class="input-wrapper">        
        <v-text-field
          label="User Name"
          outlined
          name="username"
          :persistent-placeholder="true"    
        ></v-text-field>
      </div>

      <div class="input-wrapper">
        <v-text-field
          label="Password"
          type="password"
          name="password"
          outlined
          :persistent-placeholder="true"    
        ></v-text-field>

        <!-- <a href="#" @click.prevent="forgotPassword" class="forgot">Forgot password?</a> -->
      </div>
    
      <v-btn
        block
        rounded
        tabindex="0"
        :loading="loading"
        color="primary"        
        type="submit"
      >Login</v-btn>
      <span class="error-message fadeout">{{ errorMessage }}</span>
    </form>
  </div>
</template>

<script>
import UserService from "../../services/UserService";
import axios from "../../axios";
import router from "../../router/";
//import { ref } from 'vue';


export default {
  data() {
    return {
      username: "",
      password: "",
      errorMessage: null,
      loading: false,
    };
  },
  methods: {  
    async login(e){
      const form = new FormData(e.target);
      const inputs = Object.fromEntries(form.entries());

      //TODO: ERROR 400 does not get into catch...
      UserService.Login(inputs, { withCredentials: true })
        .then(response => {
          //console.log("response:",response.data)
          axios.defaults.headers.common['Authorization'] = `Bearer ${response.data.token}`;
          //axios.defaults.headers.common['Authorization'] = 'Bearer '+localStorage.getItem('token');
          localStorage.setItem('token', response.data.token);
          //console.log("Setting use:",response.data.user, JSON.stringify(response.data.user));
          localStorage.setItem('user', JSON.stringify(response.data.user));
          //this.$store.dispatch('user', response.data.user);           
          router.push('/dashboard');
        })
        .catch(err => {
          console.log("error login: ",err);
          this.errorMessage = 'Username or password is incorrect';
        });
    },  
    forgotPassword() {
      this.$emit("forgotPassword");
    },
  },
};
</script>

<style scoped>
.logo {
  max-width: 300px;
}

.v-btn {
  min-height: 50px;
  margin-top: 35px;
}

.form-wrapper {
  display: flex;
  flex-direction: column;
  width: 28%;
  min-width: 450px;
}

form {
  box-sizing: border-box;
  padding: 80px 88px 50px;
  position: relative;
}

.input-wrapper {
  margin: 0;
  position: relative;
}

form label {
  display: block;
  font-size: 18px;
  margin: 10px 0;
}

form input {
  background-color: transparent;
  border: 1px solid #a8a6a8;
  border-radius: 106px;
  font-size: 18px;
  padding: 0;
  height: 50px;
  width: 100%;
  text-indent: 15px;
  outline: none;
}

.forgot {
  position: absolute;
  font-size: 14px;
  top: 75px;
  right: 5px;
}

.error-message {
  position: absolute;
  display: inline-block;
  width: 100%;
  padding: 0 88px;
  color: #ac2221;
  background-color: transparent !important;
  bottom: -5px;
  left: 0;
  animation: fadein 5s normal forwards;
}

.placeholer {
  height: 25px;
}

.brand {
  padding: 30px 48px 0px 90px;
  position: relative;
  width: 100%;
  cursor: default;
}

.brand .platname {
  /*
  position: absolute;
  top: 85px;
  left: 215px; */
  color: #3a2f3f;
  font-size: 42px;
  font-weight: 800;
  letter-spacing: 10px;
  display: inline-block;
}

.brand .subtitle {
  /*
  position: absolute;
  top: 140px;
  left: 215px; */
  color: #3a2f3f;
  font-size: 16px;
  opacity: 0.75;
  display: inline-block;
}

@keyframes fadein {
  0% {
    opacity: 0;
  }
  2.5% {
    opacity: 1;
  }
  80% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
</style>
